export function comparePasswords(pass: string, secondPass: string) {
  return pass === secondPass;
}
